document.addEventListener('DOMContentLoaded', function () {
    const tabsContainers = document.querySelectorAll('.reviews-slider');

    tabsContainers.forEach((tabsContainer) => {
    new Splide( tabsContainer, {
      pagination: false,
      arrows: true,
      type   : 'loop',
      perPage: 3,
      perMove: 1,
      focus  : 'center',
      gap    : '2rem',
      breakpoints: {
        1600: {
          perPage: 2,
          gap    : '1rem',
        },
        1024: {
          perPage: 1,
          gap    : '1rem',
        },
        620: {
          perPage: 1,
          gap    : '1rem',
          pagination: true,
        },
      },
    } ).mount();
    })
  });